angular.module('gym.sequences').factory('SequenceCategories', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('sequences').all('sequence_categories');
}]);
